import { useRef } from 'react';
import { useOverlayTrigger } from 'react-aria';
import { useOverlayTriggerState } from 'react-stately';

import { RouteManager } from '../../../RouteManager';

import { useI18n } from '../../../hooks/useI18nFormatters';

import { cssClass } from '../../../theme/cssClass';
import { suPx } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';

import { AnimationRemain } from '../../../components/animation/AnimationRemain';
import { GradientButtonRound } from '../../../components/buttons/GradientButtonRound';
import { ContextMenuContent } from '../../../components/common/context-menu/ContextMenuContent';
import { Overlay } from '../../../components/overlay/Overlay';

import { advancedFlowViewStore } from './store/AdvancedFlowViewStore';

export function AddCardButton(props) {
  const { i18n } = useI18n();

  const triggerRef = useRef();
  const overlayTriggerState = useOverlayTriggerState({ defaultOpen: props.defaultOpen });
  const overlayTrigger = useOverlayTrigger({ type: 'menu' }, overlayTriggerState, triggerRef);

  function handlePress() {
    overlayTriggerState.toggle();
  }

  return (
    <>
      <GradientButtonRound
        {...overlayTrigger.triggerProps}
        ref={triggerRef}
        onPress={handlePress}
        title={i18n.messageFormatter('flow.addCard')}
      >
        <GradientButtonRound.Icon
          source={glyph.core.plusMedium}
          color={theme.icon.color_white}
          size={theme.icon.size_default}
        />
        <GradientButtonRound.Text className={cssClass.showForLarge}>
          {i18n.messageFormatter('common.add')}
        </GradientButtonRound.Text>
      </GradientButtonRound>

      <AnimationRemain condition={overlayTriggerState.isOpen} delay={200}>
        {(animationRemainProps) => {
          return (
            <Overlay
              targetRef={triggerRef}
              overlayProps={overlayTrigger.overlayProps}
              overlayTriggerState={overlayTriggerState}
              offset={suPx(1)}
              animationRemainProps={animationRemainProps}
              autoFocus={true}
              restoreFocus={true}
            >
              <ContextMenuContent.ListBase
                onCloseRequest={() => {
                  overlayTriggerState.close();
                }}
              >
                <ContextMenuContent.ListItemBase
                  label={`${i18n.messageFormatter('flow.triggerCardTitle')}...`}
                  onPress={() => {
                    overlayTriggerState.close();
                    RouteManager.pushState({
                      cardDialog: {
                        type: 'trigger',
                      },
                    });
                  }}
                />
                <ContextMenuContent.ListItemBase
                  label={`${i18n.messageFormatter('flow.conditionCardTitle')}...`}
                  onPress={() => {
                    overlayTriggerState.close();
                    RouteManager.pushState({
                      cardDialog: {
                        type: 'condition',
                      },
                    });
                  }}
                />
                <ContextMenuContent.ListItemBase
                  label={`${i18n.messageFormatter('flow.actionCardTitle')}...`}
                  onPress={() => {
                    overlayTriggerState.close();
                    RouteManager.pushState({
                      cardDialog: {
                        type: 'action',
                      },
                    });
                  }}
                />

                <ContextMenuContent.Divider />

                <ContextMenuContent.ListItemBase
                  label={i18n.messageFormatter('flow.startCardTitle')}
                  hint={props.hasStartCard === true ? '1/1' : '0/1'}
                  isDisabled={props.hasStartCard === true}
                  onPress={() => {
                    overlayTriggerState.close();
                    advancedFlowViewStore.setCardCursorData({
                      cardData: {
                        type: 'start',
                        x: 0,
                        y: 0,
                      },
                    });
                  }}
                />

                <ContextMenuContent.ListItemBase
                  label={i18n.messageFormatter('flow.delayCardTitle')}
                  onPress={() => {
                    overlayTriggerState.close();
                    advancedFlowViewStore.setCardCursorData({
                      cardData: {
                        type: 'delay',
                        args: {
                          delay: {
                            number: '1',
                            multiplier: 1,
                          },
                        },
                        x: 0,
                        y: 0,
                      },
                    });
                  }}
                />

                <ContextMenuContent.ListItemBase
                  label={i18n.messageFormatter('flow.allCardTitle')}
                  onPress={() => {
                    overlayTriggerState.close();
                    advancedFlowViewStore.setCardCursorData({
                      cardData: {
                        type: 'all',
                        x: 0,
                        y: 0,
                      },
                    });
                  }}
                />

                <ContextMenuContent.ListItemBase
                  label={i18n.messageFormatter('flow.anyCardTitle')}
                  onPress={() => {
                    overlayTriggerState.close();
                    advancedFlowViewStore.setCardCursorData({
                      cardData: {
                        type: 'any',
                        x: 0,
                        y: 0,
                      },
                    });
                  }}
                />

                <ContextMenuContent.Divider />

                <ContextMenuContent.ListItemBase
                  label={i18n.messageFormatter('flow.noteCardTitle')}
                  onPress={() => {
                    overlayTriggerState.close();
                    advancedFlowViewStore.setCardCursorData({
                      cardData: {
                        type: 'note',
                        value: '',
                        color: 'yellow',
                        x: 0,
                        y: 0,
                        width: null,
                        height: null,
                      },
                    });
                  }}
                />
              </ContextMenuContent.ListBase>
            </Overlay>
          );
        }}
      </AnimationRemain>
    </>
  );
}
